import "@/App.css";
import { createBrowserRouter, RouterProvider, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/components/AuthProvider";
import { ScrollToTop } from "@/components/ScrollToTop";

// Pages
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DemoEndedPage from "@/pages/DemoEndedPage";
import DashboardPage from "@/pages/DashboardPage";
import JobsPage from "@/pages/JobsPage";
import JobBuilderPage from "@/pages/JobBuilderPage";
import JobDetailPage from "@/pages/JobDetailPage";
import JobEditPage from "@/pages/JobEditPage";
import ClientsPage from "@/pages/ClientsPage";
import CrewPage from "@/pages/CrewPage";
import EquipmentPage from "@/pages/EquipmentPage";
import EquipmentDetailPage from "@/pages/EquipmentDetailPage";
import SettingsPage from "@/pages/SettingsPage";
import UsersPage from "@/pages/UsersPage";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import HelpPage from "@/pages/HelpPage";
import SupportPage from "@/pages/SupportPage";
import XeroCallbackPage from "@/pages/XeroCallbackPage";
import ConnectAgentPage from "@/pages/ConnectAgentPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import BriefsPage from "@/pages/BriefsPage";
import BriefDetailPage from "@/pages/BriefDetailPage";
import PublicBriefFormPage from "@/pages/PublicBriefFormPage";
import TreatmentDetailPage from "@/pages/TreatmentDetailPage";
import PublicTreatmentPage from "@/pages/PublicTreatmentPage";

/**
 * Every page. The routes stay in <Routes> under one catch-all data route: a
 * data router is what makes useBlocker work (UnsavedChangesGuard), and this
 * gets it without restating each route as a route object.
 */
function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/demo-ended" element={<DemoEndedPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/new" element={<JobBuilderPage />} />
          <Route path="/jobs/:jobId" element={<JobDetailPage />} />
          <Route path="/jobs/:jobId/edit" element={<JobEditPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/crew" element={<CrewPage />} />
          <Route path="/briefs" element={<BriefsPage />} />
          <Route path="/briefs/:briefId" element={<BriefDetailPage />} />
          <Route path="/treatments/:treatmentId" element={<TreatmentDetailPage />} />
          <Route path="/brief/:token" element={<PublicBriefFormPage />} />
          <Route path="/treatment/:token" element={<PublicTreatmentPage />} />
          <Route path="/equipment" element={<EquipmentPage />} />
          <Route path="/equipment/:equipmentId" element={<EquipmentDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/help/:threadId" element={<HelpPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/support/:threadId" element={<SupportPage />} />
          <Route path="/xero/callback" element={<XeroCallbackPage />} />
          <Route path="/connect" element={<ConnectAgentPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

const router = createBrowserRouter([{ path: "*", element: <AppRoutes /> }]);

function App() {
  return (
    <ThemeProvider>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
    </ThemeProvider>
  );
}

export default App;
